import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets-39nsmqrw.emergentagent.net/job_digital-advance-lab/artifacts/upamywma_IMG-20220903-WA0000.jpg";

export default function Logo({ compact = false, className = "" }) {
  return (
    <Link to="/" className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <div className="relative h-10 w-10 rounded-full overflow-hidden shrink-0 shadow-sm ring-1 ring-black/5">
        <img
          src={LOGO_URL}
          alt="Finzpe"
          className="h-full w-full object-cover"
          loading="eager"
          decoding="async"
        />
      </div>
      {!compact && (
        <div className="font-display font-bold text-lg tracking-tight leading-none">
          Finzpe
          <div className="text-[10px] uppercase tracking-[0.2em] font-body font-medium text-muted-foreground mt-0.5">Digital Lending</div>
        </div>
      )}
    </Link>
  );
}
